import React, { useState } from 'react';
import axios from 'axios';
import GLOBALVAR from "../constants";

const AddUserForm = () => {
    const [userData, setUserData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        permissions: '' // Assuming you have a permissions field
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Send POST request to backend to add user
            const response = await axios.post(`${GLOBALVAR['SERVER_ROOT']}/api/users/add`, userData);
            console.log(response.data); // Log response from backend
            // Reset form after successful submission
            setUserData({
                firstName: '',
                lastName: '',
                email: '',
                password: '',
                permissions: ''
            });
        } catch (error) {
            console.error('Error adding user:', error);
            // Handle error
        }
    };

    return (
        <div>
            <h2>Add User</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>First Name:</label>
                    <input
                        type="text"
                        name="firstName"
                        value={userData.firstName}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Last Name:</label>
                    <input
                        type="text"
                        name="lastName"
                        value={userData.lastName}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        name="email"
                        value={userData.email}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Password:</label>
                    <input
                        type="password"
                        name="password"
                        value={userData.password}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div>
                    <label>Permissions:</label>
                    <select
                        name="permissions"
                        value={userData.permissions}
                        onChange={handleChange}
                        required
                    >
                        <option value="">Select Permissions</option>
                        <option value="Super Admin">Super Admin</option>
                        <option value="Admin">Admin</option>
                        <option value="Staff">Staff</option>
                    </select>
                </div>
                <button type="submit">Add User</button>
            </form>
        </div>
    );
};

export default AddUserForm;
